import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Observable } from "rxjs";

import { AuthenticationService } from "../authentication/authentication.service";
import { RegistrationService } from "../../login/registration-service/registration.service";

@Injectable()
export class AuthenticateGuard implements CanActivate {

	constructor(
		private authService: AuthenticationService,
		private registrationService: RegistrationService
	) { }

	public canActivate() {
		// The observable _must_ complete in order for the guard to work as expected
		return new Observable<boolean>((observer) => {
			const user = this.authService.getCurrentUser();
			if (!user) {
				this.registrationService.navigateToLogin();
				observer.next(false);
				observer.complete();
			} else if (user.isExpired()) {
				// user is expired, try to fire a refresh event for them.  If it fails we'll log them out
				this.authService.refreshUser(user).subscribe(() => {
					// Success callback, nothing to do here
					observer.next(true);
				}, () => {
					// Error callback, we got an error attempting the refresh so go to logout
					this.authService.logout();
					observer.next(false);
				}, () => {
					// complete callback
					observer.complete();
				});
			} else {
				observer.next(true);
				observer.complete();
			}
		});
	}
}
